import classNames from 'classnames'
import React from 'react'
import { CLASS_PREFIX } from 'src/constants'

import './button.scss'

type Props = {
  onClick: () => void;
  disabled?: boolean;
  variant?: 'primary' | 'secondary' | 'tertiary';
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  title: string;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  className?: string;
};

const cls = `${CLASS_PREFIX}button`

export const Button: React.FC<Props> = ({
  onClick,
  disabled,
  variant = 'primary',
  title,
  iconLeft,
  iconRight,
  size = 'medium',
  className
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={classNames(cls, `${cls}--${variant}`, `${cls}--${size}`, className)}
    >
      {iconLeft && <span className={`${cls}__icon ${cls}__icon--left`}>{iconLeft}</span>}
      {title}
      {iconRight && <span className={`${cls}__icon ${cls}__icon--right`}>{iconRight}</span>}
    </button>
  )
}
